import React from 'react';

function KFTForm() {
  return (
    <div>
      <h2>KFTForm</h2>
    </div>
  );
}

export default KFTForm;
